import styled from 'styled-components';
import { FONTS, COLORS } from '@app/src/ui';
import { Button } from '@app/src/common/Button';

interface Props {
  color: string;
}

export const FieldDescription = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 14px;
  color: ${COLORS.GRAY_TEXT};
`;

export const Disclaimer = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 12px;
  color: ${COLORS.GRAY_TEXT};
  text-align: center;
  margin: 40px 0 27px;
`;

export const ButtonPrevWrapper = styled(Button)`
  height: 55px;
  font-size: 14px;
  font-weight: 600;
  svg {
    flex: 0 0 auto;
    margin-right: 6px;
  }
  span {
    text-align: left;
  }
`;

export const ButtonNextWrapper = styled(Button)`
  height: 55px;
  font-size: 14px;
  font-weight: 600;
  svg {
    transform: rotate(180deg);
    margin-left: 6px;
  }
`;

export const TermsAndConditions = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 14px;
  margin-left: 8px;
`;

export const LinkTermsAndConditions = styled.a`
  color: ${(props: Props) => props.color};
  font-size: 14px;
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
